import { BANNER_RESERVED_WORLD_PX } from "../data/balance.js";

const ANDROID_BANNER_HEIGHT_CSS_PX = 50;
const ANDROID_STATUS_BAR_FALLBACK_CSS_PX = 24;

export interface BannerReserveWorldInput {
  readonly isNative: boolean;
  readonly screenCssWidth: number;
  readonly designWidth: number;
  readonly safeTopWorld: number;
}

/**
 * Native top banner reserve를 Phaser world px로 환산한다.
 * safe-area top이 이미 들어온 기기는 status bar fallback을 더하지 않아 중복 여백을 막는다.
 */
export function resolveBannerReserveWorldPx(input: BannerReserveWorldInput): number {
  if (!input.isNative) return BANNER_RESERVED_WORLD_PX;
  if (input.screenCssWidth <= 0 || input.designWidth <= 0) return BANNER_RESERVED_WORLD_PX;
  const cssToWorld = input.designWidth / input.screenCssWidth;
  const bannerWorld = ANDROID_BANNER_HEIGHT_CSS_PX * cssToWorld;
  const statusFallbackWorld =
    input.safeTopWorld > 0 ? 0 : ANDROID_STATUS_BAR_FALLBACK_CSS_PX * cssToWorld;
  return Math.max(BANNER_RESERVED_WORLD_PX, bannerWorld + statusFallbackWorld);
}
